import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-feedback-container',
  templateUrl: './feedback-container.component.html',
  styleUrls: ['./feedback-container.component.scss']
})
export class FeedbackContainerComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<FeedbackContainerComponent>) { }

  ngOnInit() {
  }

  onSend(event) {
    this.dialogRef.close();
  }
}
